<template>
  <div class="MenuBtnComp">
    <MultiBtn
      v-if="labels"
      id="menu-modal-open"
      icon="bars"
      :text="labels.btn_text"
      :label="labels.btn_title"
      :theme="theme"
      is-nav
      @click.native="$store.commit('menuModalOpen', true)"
    />
  </div>
</template>

<script>
import MultiBtn from '@/components/buttons/MultiBtn.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'MenuBtn',

  components: {
    MultiBtn
  },

  computed: {
    // Data
    ...mapGetters([ 'myStore' ]),
    // Menu Button
    labels() { return this.myStore(['labels', 'header', 'menu_button']) ?? {} },
    styles() { return this.myStore(['styles', 'header', 'menu_button']) ?? {} },
    theme() { return this.styles.button_style ?? 'button_style_4' },
  }
}
</script>
